import { FaUtensils } from "react-icons/fa";
import FoodDetailThemeBase from "./FoodDetailThemeBase";

const GREEN = "#153A2E";
const GOLD = "#C79A4B";
const CREAM = "#F8F5EC";

const theme = {
  pageStyle: { backgroundColor: CREAM },
  headerClassName: "sticky top-0 z-20",
  headerStyle: { backgroundColor: GREEN },
  headerInnerClassName: "mx-auto flex h-16 max-w-2xl items-center justify-between px-4 text-white",
  iconButtonClassName: "flex h-11 w-11 items-center justify-center rounded-xl text-xl hover:bg-white/10",
  titleClassName: "font-black",
  badgeClassName: "absolute -left-1 -top-1 rounded-full px-1.5 text-[10px] font-bold",
  badgeStyle: { backgroundColor: GOLD, color: GREEN },
  cardClassName: "overflow-hidden rounded-2xl bg-white shadow-sm",
  PlaceholderIcon: FaUtensils,
  placeholderClassName: "flex aspect-[4/3] items-center justify-center text-6xl sm:aspect-[16/9]",
  placeholderStyle: { backgroundColor: "#EFE9D8", color: GOLD },
  itemTitleClassName: "text-2xl font-black",
  itemTitleStyle: { color: GREEN },
  descriptionClassName: "mt-3 leading-7 text-gray-500",
  priceStyle: { color: GOLD },
  stepperClassName: "flex items-center rounded-full bg-white shadow",
  ctaClassName: "min-h-12 flex-1 rounded-full px-5 font-bold text-white shadow-lg",
  ctaStyle: { backgroundColor: GREEN },
};

const MizbanSignatureFoodDetailTheme = (props) => <FoodDetailThemeBase {...props} theme={theme} />;

export default MizbanSignatureFoodDetailTheme;
